import styled from "styled-components";
import { device } from "./device";
const FooterBlock = styled.div`
  display: flex;
  flex-direction: column;

  background-color: #434350;

  padding: 30px 20px 30px 50px;
  @media ${device.mobile} {
    padding: 30px 20px 30px 20px;
  }
`;
const Logo = styled.img`
  height: 50px;
  width: 200px;
`;

const Title = styled.div`
  color: #76edf9;
  font-size: 20px;
  line-height: 24px;
  margin-top: 20px;
`;

const SubTitle = styled.div`
  color: rgb(204, 204, 204);
  font-size: 14px;
  line-height: 14px;
  margin-top: 20px;
`;

const Footer = () => {
  return (
    <FooterBlock>
      <Logo src={`${process.env.PUBLIC_URL}/footer-logo.png`} />
      <Title>Utilizing Blockchain to Change the World</Title>
      <SubTitle>
        © {new Date().getFullYear()} TBCASoft, Inc. All rights reserved.
      </SubTitle>
    </FooterBlock>
  );
};
export default Footer;
